import { render, staticRenderFns } from "./DisplayCounter.vue?vue&type=template&id=7815ba0a&scoped=true"
import script from "./DisplayCounter.vue?vue&type=script&lang=js"
export * from "./DisplayCounter.vue?vue&type=script&lang=js"
import style0 from "./DisplayCounter.vue?vue&type=style&index=0&id=7815ba0a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815ba0a",
  null
  
)

export default component.exports